import { Component, Input, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { FilesService } from 'src/app/core/services/files.service';
import { ModalDirective } from '../../directives/modal.directive';
import { getFileType } from '../../helpers/variables';
import { ModalService } from 'src/app/core/services/modal.service';
import { SharedService } from 'src/app/core/services/shared.service';
import { translations } from 'src/i18n/translations';

@Component({
  selector: 'app-download-file',
  templateUrl: './download-file.component.html'
})
export class DownloadFileComponent {
  @Input() url: string;
  @ViewChild(ModalDirective, { static: true }) modal: ModalDirective;

  constructor(
    private filesService: FilesService,
    private http: HttpClient,
    private modalService: ModalService,
    private sharedService: SharedService
  ) {}

  downloadFile(): void {
    this.http.get(this.url).subscribe({
      next: (response: { link: string } | { url: string }) => {
        let link = '';

        if (isResponseWithUrl(response)) {
          link = response.url;
        } else if (isResponseWithLink(response)) {
          link = response.link;
        }

        if (link) {
          this.filesService.downloadFile(link);
        } else {
          this.sharedService.showNotification(translations[this.sharedService.language].fileNotReady);
        }
      },
      error: () => this.sharedService.showError(translations[this.sharedService.language].fileFail)
    });
  }

  openFile(): void {
    this.http.get(this.url).subscribe(
      (response: { link: string } | { url: string }) => {
        let link = '';

        if (isResponseWithUrl(response)) {
          link = response.url;
        } else if (isResponseWithLink(response)) {
          link = response.link;
        }

        const fileType = getFileType(link);
        if (fileType) {
          this.modalService.showFilePreview(link, fileType, this.modal);
        } else {
          this.sharedService.showNotification(translations[this.sharedService.language].filePreviewNotAvailable);
        }
      },
      () => this.sharedService.showError(translations[this.sharedService.language].fileFail)
    );
  }
}

function isResponseWithUrl(response: { link: string } | { url: string }): response is { url: string } {
  return (response as { url: string }).url !== undefined;
}

function isResponseWithLink(response: { link: string } | { url: string }): response is { link: string } {
  return (response as { link: string }).link !== undefined;
}
